// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "LazyIdentificationForm" + "." + "2db8ecc488dd8d216847" + ".css";
};